var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"90vh"}},[(_vm.hasJobList)?[_c('JobListHeader'),_c('JobList',{attrs:{"jobs":_vm.jobs}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }